import { deviceId, hubspotBaseUrl, locale, portalId, leadinPluginVersion, } from '../constants/leadinConfig';
import { initApp } from './appUtils';
import { fetchAccessToken } from '../api/wordpressApiClient';
import { isEmbedderReady } from './embedderReady';
export function initBackgroundApp(initFn) {
    function main() {
        if (Array.isArray(initFn)) {
            initFn.forEach(callback => callback());
        }
        else {
            initFn();
        }
    }
    initApp(main);
}
const getLeadinConfig = () => {
    return {
        leadinPluginVersion,
    };
};
export const getOrCreateBackgroundApp = (accessToken = '', expiresIn = 0) => {
    if (window.LeadinBackgroundApp) {
        return window.LeadinBackgroundApp;
    }
    if (!isEmbedderReady()) {
        return null;
    }
    const { IntegratedAppEmbedder, IntegratedAppOptions } = window;
    const options = new IntegratedAppOptions()
        .setLocale(locale)
        .setDeviceId(deviceId)
        .setLeadinConfig(getLeadinConfig())
        .setAccessToken(accessToken, expiresIn);
    const embedder = new IntegratedAppEmbedder('integrated-plugin-proxy', portalId, hubspotBaseUrl, () => { }).setOptions(options);
    embedder.attachTo(document.body, false);
    embedder.setTokenRenewalCallback(fetchAccessToken);
    embedder.postStartAppMessage(); // lets the app know all data has been passed to it
    window.LeadinBackgroundApp = embedder;
    return window.LeadinBackgroundApp;
};
